module.exports = __webpack_public_path__ + "img/3.df6a2887.jpg";